import Immutable from 'immutable';

function _replaceArg (stringWithArgs: string, index: number, arg: any): string {
  return stringWithArgs.replace('{' + index + '}', arg.toString());
}

function replaceArgs (stringWithArgs: string, ...args: any): string {
  for (let argIndex = 0; argIndex < args.length; argIndex++) {
    stringWithArgs = _replaceArg(stringWithArgs, argIndex, args[argIndex]);
  }

  return stringWithArgs;
}

function replaceArgsList (stringWithArgs: string, args: Immutable.List<any>): string {
  for (let argIndex = 0; argIndex < args.size; argIndex++) {
    stringWithArgs = _replaceArg(stringWithArgs, argIndex, args.get(argIndex));
  }

  return stringWithArgs;
}

export default {
  replaceArgs,
  replaceArgsList
};
